const TX_SJ = "Tx_Sj",
  TX_DJ = "Tx_Dj",
  TX_RJ = "Tx_Rj",
  TX_SJ_FREQUENCY = "Tx_Sj_Frequency",
  TX_PJ_FREQUENCY = "Tx_PJ_Frequency",
  TX_DCD = "Tx_DCD",
  RX_SJ = "Rx_Sj",
  RX_DJ = "Rx_Dj",
  RX_RJ = "Rx_Rj",
  RX_NOISE = "Rx_Noise",
  RX_DCD = "Rx_DCD",
  TX_JITTER_PDF = "Tx_JitterPDF",
  RX_JITTER_PDF = "Rx_JitterPDF",
  RANDOM = "Random",
  DJRJ = "DJRJ",
  DUAL_DIRAC = "Dual_Dirac",
  TX_PJ_AMPLITUDE = "Tx_PJ_Amplitude",
  TX_CLOCK_DCD = "Tx_Clock_DCD",
  RX_SJ_AMPLITUDE = "Rx_SJ_Amplitude",
  RX_AMPLITUDE_NOISE = "Rx_Amplitude_Noise";

const TX_JITTERS = [
  TX_SJ,
  TX_DJ,
  TX_RJ,
  TX_SJ_FREQUENCY,
  TX_DCD
],
  RX_JITTERS = [
    RX_SJ,
    RX_DJ,
    RX_RJ,
    RX_NOISE,
    RX_DCD
  ],
  BIT_BY_BIT = "Bit-by-bit",
  STATISTICAL = "Statistical";


const ENABLE_CTLE_OR_FFE = "enableCTLEOrFFE",
  DFE_TYPE = "DFEType";

const IBIS_TX_JITTERS = [
  TX_DCD,
  TX_CLOCK_DCD,
  TX_PJ_AMPLITUDE,
  TX_PJ_FREQUENCY,
  TX_JITTER_PDF
],
  IBIS_RX_JITTERS = [
    RX_SJ_AMPLITUDE,
    RX_AMPLITUDE_NOISE,
    RX_JITTER_PDF
  ];

export {
  TX_JITTERS,
  RX_JITTERS,
  BIT_BY_BIT,
  STATISTICAL,
  TX_PJ_FREQUENCY,
  TX_PJ_AMPLITUDE,
  TX_DCD,
  TX_CLOCK_DCD,
  IBIS_TX_JITTERS,
  IBIS_RX_JITTERS,
  TX_JITTER_PDF,
  RX_SJ_AMPLITUDE, RX_AMPLITUDE_NOISE, RX_JITTER_PDF,
  TX_SJ, TX_DJ, TX_RJ, TX_SJ_FREQUENCY,
  RX_SJ, RX_DJ, RX_RJ, RX_NOISE, RX_DCD,
  RANDOM, DJRJ, DUAL_DIRAC, DFE_TYPE, ENABLE_CTLE_OR_FFE
}